import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/frontdoor/login.service';
import { RoleService } from '../../../services/frontdoor/role.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit {
  isAuthenticated = false;
  roles: string[] = [];
  username: string = '';

  constructor(
    private loginService: LoginService,
    private roleService: RoleService
  ) {}

  ngOnInit(): void {
    // Subscribe to authentication state so we know if the user is signed in.
    this.loginService.authState$.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      if (isAuth) {
        // When authenticated, load the user profile and set username and roles.
        this.loginService.getProfile().subscribe((res: any) => {
          if (res.success && res.user) {
            this.username = res.user.username;
            // Check if the role is provided as a comma-separated string.
            if (res.user.role.indexOf(',') !== -1) {
              this.roles = res.user.role.split(',').map((r: string) => r.trim());
            } else {
              this.roles = [res.user.role];
            }
          }
        });
      } else {
        // If not authenticated, clear out user information.
        this.username = '';
        this.roles = [];
      }
    });
  }

  // Helper method to check if the user has a specific role.
  hasRole(roleName: string): boolean {
    return this.roles.includes(roleName);
  }
}

